import React from 'react';

// TODO apply same wrappers as for the CMP manu
export const AsyncJsmTmpProjectSettingsSidebar = () => (
	<div>Placeholder: JSM TMP project settings menu Content</div>
);
